import Choices from 'choices.js'
import lang from '@/plugins/lang'

Choices.defaults.options.noResultsText = lang.t('choicesjs:noResultsText')
Choices.defaults.options.noChoicesText = lang.t('choicesjs:noChoicesText')
Choices.defaults.options.itemSelectText = lang.t('choicesjs:itemSelectText')
Choices.defaults.options.uniqueItemText = lang.t('choicesjs:uniqueItemText')
Choices.defaults.options.customAddItemText = lang.t('choicesjs:customAddItemText')
